import {
  Grid2 as Grid,
  Stack,
  Typography,
  Link,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material"
import { AllegatoImmagine } from "../types"
import { useTranslation } from "react-i18next"
import { useState } from "react"
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation } from "swiper/modules"
// @ts-expect-error
import "swiper/css"
// @ts-expect-error
import "swiper/css/navigation"
// @ts-expect-error
import "swiper/css/navigation"

export default function AllegatiImmagineGrid({ allegati_data }: { allegati_data: AllegatoImmagine[] }) {
  const { t } = useTranslation()
  const [currentSlide, setCurrentSlide] = useState<null | number>(null)

  return (
    <>
      <Grid container spacing={2}>
        {allegati_data?.map((a, idx) => (
          <Grid size={8} key={a.id}>
            <Stack direction="row" spacing={1} alignItems="center">
              <Paper sx={{ p: 1 }} onClick={() => setCurrentSlide(idx)}>
                <img src={a.attachment_thumbnail} alt={a.nome_originale || a.nome}></img>
              </Paper>
              <Stack>
                <Link href={a.attachment} target="_blank" color="text.primary" download>
                  <Typography variant="body1">{a.nome_originale || a.nome}</Typography>
                </Link>
                <Typography variant="body2" color="text.secondary">
                  {a.note}
                </Typography>
              </Stack>
            </Stack>
          </Grid>
        ))}
      </Grid>
      {allegati_data?.length === 0 && (
        <Typography variant="body1" color="text.secondary">
          {t("general.senza_allegati")}
        </Typography>
      )}
      <Dialog
        open={currentSlide !== null}
        onClose={() => {
          setCurrentSlide(null)
        }}
        onToggle={() => {
          setCurrentSlide(null)
        }}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>Immagini allegate</DialogTitle>
        <DialogContent>
          <Stack direction={"row"}>
            <Swiper
              initialSlide={currentSlide!}
              onSlideChange={(swiper) => {
                setCurrentSlide(swiper.activeIndex)
              }}
              spaceBetween={10}
              slidesPerView={1}
              navigation={true}
              modules={[Navigation]}
            >
              {allegati_data?.map((a, idx) => (
                <SwiperSlide key={idx}>
                  <img
                    src={a.attachment}
                    style={{
                      maxWidth: "100vw",
                      height: "70vh",
                      objectFit: "contain",
                    }}
                    width={"100%"}
                    height={"450px"}
                    alt={a.nome_originale || a.nome}
                    // onClick={() => {
                    //   setCurrentSlide(null)
                    // }}
                  />
                  <div style={{ marginTop: 30 }}>
                    <Typography variant="body1">{a.nome_originale || a.nome}</Typography>
                    <Typography variant="body2">{a.note}</Typography>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </Stack>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </>
  )
}
